import { FC } from "react";
import { Row, Col } from "antd"
import { ChangePasswordButton, ErrorMessage } from "./elements";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { Formik, FormikProps } from "formik";
import { PersonalDetailsFormSchema } from "./validation";

type Props = {
  details: any;
  onClickChangePassword: () => void;
  isEditMode?: boolean;
  innerRef?: React.Ref<FormikProps<any>>;
  onUpdateAccountDetails: (values: any) => void;
};

const PersonalDetailsForm: FC<Props> = ({ onUpdateAccountDetails, innerRef, details, onClickChangePassword, isEditMode }) => {
  return (
    <Formik 
      onSubmit={onUpdateAccountDetails}
      innerRef={innerRef}
      initialValues={{ 
        fullName: details?.fullName, 
        email: details?.email, 
        accessType: details?.accessType, 
        password: details?.password
      }}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={PersonalDetailsFormSchema}
      > 
      {({ values, handleChange, handleSubmit, errors }) => (
        <form onSubmit={handleSubmit}>
        <Row gutter={[16, 0]}>
          <Col span={12}>
              <InputWithLabel error={!!errors.fullName} label="Full Name" onChange={handleChange('fullName')} value={values.fullName} disabled={!isEditMode} type="default" />
              {errors.fullName && (<ErrorMessage>{errors.fullName}</ErrorMessage>)}
          </Col>
          <Col span={12}>
              <InputWithLabel error={!!errors.email} label="Email Address" onChange={handleChange('email')} value={values.email} disabled={!isEditMode} type="default" />
              {errors.email && (<ErrorMessage>{errors.email}</ErrorMessage>)}
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
              <InputWithLabel label="Access Type" value={values.accessType} disabled type="default" />
          </Col>
          <Col span={12}>
              <InputWithLabel visibilityToggle={false} label="Password" value={values.password} disabled type="password" />
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12} offset={12}>
              <ChangePasswordButton type="text" danger onClick={onClickChangePassword}>Change Password</ChangePasswordButton>
          </Col>
        </Row>
      </form>
      )} 
    </Formik>
    
  )
}

export default PersonalDetailsForm;